// 繁體中文（台灣 / 香港）
// 來源：手動繁化自 zh-CN.ts，已替換以下術語：
// 用戶 / 影片 / 攝影機 / 設備 / 門店 / 訊息 / 即時 / 設定 / 預設 / 伺服器 / 網路 / 軟體
export default {
	app: {
		brand_zh: '悠絡客',
		brand_en: 'ULUCU',
	},
	common: {
		todo_module: '此模組尚未實作，開發中',
		loading: '載入中…',
		no_data: '暫無資料',
		select_store: '選擇門店',
		show_raw: '檢視原始回應',
		reload: '重新整理',
		filter: '篩選',
		cancel: '取消',
		back: '返回',
	},
	group: {
		core: '核心',
		major: '主要',
		support: '業務支援',
		value_add: '增值',
	},
	tabbar: {
		monitor: '監控',
		home: '首頁',
		store: '門店',
		application: '應用',
		incidents: '事件',
		analytics: '分析',
		operations: '營運',
		account: '帳戶',
		video: '影片',
		reports: '報表',
		workbench: '工作台',
		messages: '訊息',
		profile: '我的',
		messages_title: '訊息中心',
		reports_title: '顧客分析',
	},
	ops: {
		title: '營運',
		subtitle: '巡店、AI 巡檢與設備協作',
		available: '可用功能',
		permission_required: '需開通或確認',
		empty: '暫無可用功能',
		view_status: '檢視狀態',
	},
	capability: {
		available_short: '目前區域可用',
		permission_required_short: '需後台開通權限',
		unknown_short: 'API 覆蓋待確認',
		region_unavailable_short: '目前區域不可用',
		permission_required_desc: '目前帳號無權使用此模組。海外原生提示：You do not have the right to this module.',
		unknown_desc: '此能力在 APAC/Mexico 的 API 覆蓋尚未完全確認，需要先做介面驗證再開放給用戶。',
		region_unavailable_desc: '此能力屬於中國區能力，在目前 APAC/Mexico 部署中不應開放。',
		back_to_operations: '返回營運',
	},
	root: {
		monitor: {
			subtitle: '門店影片、設備狀態與多畫面巡看',
			store_count: '門店',
			online_devices: '在線設備',
			offline_devices: '離線設備',
			favorites: '收藏',
			tools: '監控工具',
			stores: '門店與通道',
			offline_action: '檢視離線門店',
			offline_filter_active: '正在篩選離線',
			tool_store: '門店管理',
			tool_store_hint: '檢視門店資料、分組與營運狀態',
			tool_device: '設備狀態',
			tool_device_hint: '檢查設備在線、離線與通道狀態',
			tool_multi_view: '多畫面',
			tool_multi_view_hint: '先選擇門店，再開啟多通道巡看',
			tool_multi_view_empty: '暫無可巡看的門店',
			multi_view_select_store: '選擇門店',
			multi_view_store_count: '{{online}}/{{total}} 在線',
			multi_view_no_online: '無在線通道',
		},
		analytics: {
			subtitle: '客流、會員、車流與經營洞察',
			visible_modules: '展示模組',
			primary_period: '主週期',
			trend_period: '趨勢週期',
			currency: '幣種',
			tools: '分析工具',
			insights: '洞察摘要',
		},
		incidents: {
			subtitle: '待處理事件、告警與門店訊息',
			pending: '待處理事件',
			pending_hint: '需要營運跟進',
			today: '今日事件',
			today_hint: '今天全部事件',
			alerts: '告警訊息',
			alerts_hint: '防損與異常提醒',
			visible_types: '訊息類型',
			unread: '未讀',
			loaded: '已載入',
			status: '狀態',
			live: '即時',
			tools: '事件工具',
			workflow: '處理入口',
			status_overview: '事件狀態',
			recent_messages: '最近訊息',
			inbox: '事件收件箱',
			action_event: '處理事件',
			action_event_hint: '查看待處理、申訴與複核',
			action_alert: '查看告警',
			action_alert_hint: '定位異常門店與告警訊息',
			action_message: '訊息中心',
			action_message_hint: '查看全部通知與系統訊息',
			refresh: '重新整理事件概覽',
			updated_at: '更新於 {{time}}',
			not_updated: '尚未更新',
			partial_data: '部分事件資料暫不可用',
			message_load_failed: '訊息載入失敗',
			message_empty: '目前分類暫無訊息',
		},
		account: {
			subtitle: '組織、區域、語言與支援服務',
			region: '區域',
			language: '語言',
			recent_count: '最近觀看',
			support_count: '支援入口',
			profile: '帳戶資料',
			preferences: '區域與語言',
			profile_hint: '姓名、手機、郵箱與頭像',
			language_hint: '中文 / Español México',
			activity: '活動記錄',
			support: '支援服務',
		},
	},
	wb: {
		evaluation: '門店考評',
		free_patrol: '自由巡檢',
		self_inspect: '門店自檢',
		timed_check: '定時點檢',
		ai_patrol: 'AI 巡檢',
		report_audit: '報告審核',
		workorder: '整改工單',
		reward: '獎懲中心',
		custom: '自定義',
		customize: '自訂',
		saved: '已儲存',
		saved_local_only: '已儲存到本地（雲端同步失敗）',
		locked: '未開通',
		self_check: '門店自點檢',
		cust_analysis: '顧客分析',
		heatmap: '熱區分析',
		apparel: '服裝分析',
		flow_alert: '客流預警',
		member_id: '會員識別',
		open_store: '開店籌建',
		announce: '公告',
		task: '任務',
		report_in: '報備',
		staff: '員工管理',
		cert: '證書管理',
		university: '悠學堂',
		huiting: '慧聽',
		store_data: '門店資料',
		pic_detect: '畫面檢測',
		cat: {
			patrol: '巡店通',
			customer: '客流洞察',
			enterprise: '企業助手',
			other: '其他應用',
		},
		editor: {
			title: '管理應用',
			cancel: '取消',
			ok: '確定',
			hint: '拖動可調整應用位置',
			shown: '首頁應用',
		},
	},
	store_video: {
		tab_video: '門店影片',
		tab_data: '門店資料',
		store_data_unavailable: '門店資料將單獨復刻。本頁只復刻門店影片列表。',
		organization: '組織',
		organization_all: '全部組織',
		organization_empty: '暫無組織資料',
		organization_failed: '組織篩選暫不可用：{{reason}}',
		organization_store_count: '{{count}} 家門店',
		filter: '篩選',
		search: '搜尋',
		search_placeholder: '請輸入門店名稱或門店代碼',
		favorite_only: '只看收藏',
		summary_one: '共 {{count}} 家門店，在線率 {{rate}}',
		summary: '共 {{count}} 家門店，在線率 {{rate}}',
		offline_count: '離線 {{count}}',
		online_count: '在線 {{count}}',
		total_count: '總計 {{count}}',
		created_at: '門店建立時間',
		open_multi_view: '打開多畫面',
		sort_title: '排序',
		sort_default: '預設',
		sort_default_ranking: '預設排名',
		sort_high_to_low: '從高到低',
		sort_low_to_high: '從低到高',
		sort_offline: '離線優先',
		sort_create: '建立時間',
		sort_name: '門店名稱',
		favorite_store_video: '收藏門店影片',
		favorite_store_data: '收藏門店資料',
		no_collection: '暫無收藏',
		filter_data: '資料',
		filter_time: '時間',
		metric_entry_number: '進店人數',
		metric_total_number: '總人數',
		metric_total_sales: '總銷售額',
		metric_ecr: '成交率',
		metric_events: '事件',
		metric_turnover_rate: '周轉率',
		time_today: '今天',
		time_yesterday: '昨天',
		time_week: '本週',
		time_seven: '近 7 天',
		time_month: '本月',
		time_thirty: '近 30 天',
		calling_store_manager: '正在呼叫店長',
	},
	settings: {
		account: '帳號與語言',
		app: '應用資訊',
		storage: '本地儲存',
		support: '支援服務',
		runtime: '運行環境',
		runtime_app: '手機 App',
		runtime_web: '瀏覽器 Web',
		version: '版本',
		version_hint: '目前前端包版本',
		clear_recent: '清空最近觀看',
		clear_recent_hint: '目前 {{count}} 條本地觀看記錄',
		clear_recent_success: '最近觀看已清空',
		feedback_hint: '提交投訴建議',
		hotline_hint: '查看目前地區支援方式',
		logout: '登出',
	},
	mtab: {
		video: {
			brand_full: '上海悠絡客電子科技股份有限公司',
			search_placeholder: '請輸入門店名稱或門店代碼',
			filter: '篩選',
			tab_all: '全部',
			tab_fav: '收藏',
			summary_one: '共 {{count}} 家門店，設備總在線率: {{rate}}',
			summary: '共 {{count}} 家門店，設備總在線率: {{rate}}',
			offline_count_one: '{{n}} 台設備離線',
			offline_count: '{{n}} 台設備離線',
			device_online: '在線',
			device_offline: '離線',
			all_online: '全部在線',
			no_device: '暫無設備',
			view_all: '檢視全部',
		},
		msg: {
			system: '系統訊息',
			event: '事件訊息',
			examine: '考評訊息',
			critical: '重點人員到店',
			empty: '近 2 天暫無訊息～',
		},
		profile: {
			guest: '未登入',
			subtitle: '客戶演示帳號',
			album: '我的相簿',
			recent: '最近觀看',
			repair: '線上報修',
			repair_log: '報修記錄',
			hotline: '維修熱線',
			feedback: '投訴建議',
			changelog: '更新日誌',
			settings: '設定',
			settings_hint: '語言、版本、快取與登出',
			recent_empty: '暫無觀看記錄',
			recent_view_all: '查看全部',
			edit_profile: '個人資料',
			edit_personal_data: '編輯個人資料',
			name: '名字',
			mobile: '手機',
			mobile_phone: '手機號碼',
			email: '郵箱',
			email_address: '郵箱地址',
			email_placeholder: '請輸入內容',
			edit_avatar: '編輯頭像',
			save: '儲存',
			save_success: '已儲存',
			save_unavailable: '儲存功能暫未開放',
			online: '線上',
			offline: '離線',
			hotline_label: '客戶服務熱線',
			call: '撥打',
			feedback_placeholder: '請輸入您的建議或意見…',
			feedback_submit: '提交',
			feedback_required: '請填寫內容',
			feedback_success: '感謝您的反饋',
			changelog_empty: '暫無更新日誌',
		},
		rep: {
			pos_input: 'POS 錄入',
			portrait: '顧客畫像',
			precise: '精準客流分析',
			batch: '批次客流',
			realtime: '即時客流',
			consume: '消費分析',
			distribution: '客流分布',
			funnel: '轉化漏斗',
			duration: '停留時長分析',
			rank: '門店排行',
			store_filter: '目前 {{count}} 個門店',
			overview: '資料總覽',
			mom: '環比',
			yoy: '同比',
			compare_range: '環比日期',
			pass_count: '經過客流',
			enter_count: '進店客流',
			enter_conv: '進店轉化率',
			try_count: '試穿客流',
			try_conv: '試穿轉化率',
			member_count: '到店會員',
			stay_duration: '人均停留時長(分)',
			deal_conv: '成交轉化率',
			leave_count: '離店客流',
			invoice_count: '交易筆數',
			amount: '銷售額',
			commodity_count: '商品數',
			avg_enter: '日均進店',
			hour: '時',
			day: '天',
			flow_trend: '客流總體趨勢',
			daily_avg: '日均客流',
			peak: '客流峰值',
			valley: '客流谷值',
		},
	},
	player: {
		hd: '高清',
		sd: '標清',
		fill: '滿屏',
		fit: '適應',
		live: '即時',
		playback: '回放',
		all: '全部',
		view_legend: '檢視圖例',
		no_device: '請選擇設備',
		no_stream: '尚無視訊流',
		no_history: '當日無錄影',
		no_record_at_time: '該時刻無錄影',
		history_segment_count: '{{count}} 段錄影',
		playback_started: '回放開始',
		screenshot_done: '截圖已下載',
		fn_screenshot: '截圖',
		fn_intercom: '語音對講',
		fn_record: '錄影',
		fn_event: '建立事件',
		fn_ptz: '雲台操控',
		fn_pos: '小票查詢',
		fn_record_stop: '停止錄影',
		recording_started: '正在錄影…',
		recording_saved: '錄影已儲存',
		cap_unsupported: '此設備不支援此功能',
		share: '分享',
		video_init_failed: '影片初始化失敗...',
	},
	ptz: {
		no_permission: '目前帳號無雲台控制權限，請聯絡管理員在 ulucu 後台開通',
	},
	rename: {
		title: '修改通道別名',
		placeholder: '請輸入新別名',
		success: '已修改',
		failed: '修改失敗',
	},
	channel: {
		select: '選擇通道',
		count: '{{count}} 通道',
	},
	store_detail: {
		tab_devices: '設備列表',
		tab_overview: '資料概況',
		copy: '複製',
		copied: '已複製',
		copy_failed: '複製失敗',
		created_at: '門店建立時間',
		devices_all: '全部設備',
		devices_online: '線上設備',
		devices_offline: '離線設備',
		cat_all: '全部設備',
		cat_camera: '攝影機',
		cat_audio: '語音設備',
		my_nvr_devices: '我的 nvr 設備',
		multi_view: '多畫面預覽',
		open_video: '開啟影片',
		more: '更多',
		status_online: '在線',
		status_offline: '離線',
		offline_hint: '設備離線，暫不可播放',
		offline_unplayable: '設備離線，暫不可播放',
		call_owner: '呼叫店長',
		no_phone: '此門店無電話',
		repair_log: '報修記錄',
		service_hotline: '維修熱線',
		delete_store: '刪除門店',
		confirm_delete: '確認刪除門店？',
		confirm_delete_ok: '刪除',
		deleted: '已刪除',
		delete_failed: '刪除失敗',
	},
	repair: {
		title: '線上報修',
		store: '門店選擇',
		contact: '聯絡人',
		contact_phone: '聯絡電話',
		store_phone: '門店電話',
		describe: '故障描述',
		optional: '選填',
		add_images: '新增圖片',
		images_tip: '請上傳能說明故障問題的圖片，以便我們及時排查和解決',
		tip: '為保障反饋的問題及時解決，建議報修對應故障方案後，再進行平台報修',
		submit: '提交',
		contact_required: '請輸入聯絡人',
		phone_required: '請輸入聯絡電話',
		describe_required: '請輸入故障描述',
		success: '報修成功',
		failed: '報修失敗',
		over_limit: '目前門店待處理報修已達上限，請處理已有報修記錄後再提交新的報修。',
		history: '報修記錄',
	},
	hotline: {
		cn_desc: '中國區帳號可直接撥打客戶服務熱線。',
		local_label: '本地支援',
		local_value: 'APAC / México',
		local_desc: '墨西哥與 APAC 使用者不使用中國 400 熱線，請透過反饋入口或本地客戶經理處理支援請求。',
		feedback_action: '提交支援請求',
	},
	inspect: {
		status: '狀態',
		overdue: '已超期',
		progress: '進度',
	},
	patrol: {
		total_plans: '巡店計劃總數',
		completed: '已完成',
		overdue: '已超期',
		completion_rate: '巡店完成率',
	},
	message: {
		unread_by_category: '按分類未讀數',
		unread: '未讀',
		recent: '最近訊息',
		cat_all: '全部',
		cat_event: '事件',
		cat_alarm: '告警',
		cat_examine: '點檢',
		cat_system: '系統',
		cat_share: '分享',
		cat_face: '人臉識別',
		cat_human_alarm: '人形告警',
		cat_shop_inspection: '巡店通',
		cat_detachment_detection: '脫崗偵測',
		cat_spot_inspection: '點檢任務',
		cat_black_list: '黑名單',
		cat_youxun_moveai: '悠巡 移動 AI',
		cat_youxun_picai: '悠巡 圖片 AI',
		cat_pos_trade: 'POS 交易',
		cat_youqin: '悠勤考勤',
		cat_face_mask: '口罩識別',
		cat_data_warning: '數據預警',
		cat_take_place: '事件觸發',
		cat_youxun_advancedai: '悠巡 高級 AI',
		cat_youxun_paidui: '悠巡 排隊',
		cat_shelf_analysis: '貨架分析',
	},
	alert: {
		total: '告警總數',
		pending: '待處理',
		handled: '已處理',
	},
	incident_domain: {
		title: '事件處理工作台',
		subtitle: '事件、告警與訊息統一處理',
		partial_data: '部分事件資料暫不可用',
		alert_unread: '未讀告警',
		message_unread: '未讀訊息',
		status_overview: '事件狀態總覽',
		alert_workbench: '告警處置',
		alert_note: '目前已接入告警統計',
		alert_note_desc: '告警明細需要事件類型字典後開放；現階段請先從事件狀態和告警訊息定位待處理風險。',
		message_workbench: '訊息處理',
		no_messages: '目前分類暫無訊息',
		event_message_hint: '事件訊息還有 {{count}} 條未讀，可切換到訊息中心處理。',
	},
	store: {
		all_stores: '全部門店',
		groups: '門店分組',
		total: '門店總數',
		online: '營業中',
		with_device: '已裝設備',
		has_device: '有設備',
		stores_in_group: '家門店',
	},
	heatmap: {
		todo_visualization: '熱力圖視覺化待補',
		todo_desc: '原始資料已取得（見下方）。後續將用 ECharts heatmap 渲染。',
	},
	msg: {
		order_title: '訊息類型排序',
		save: '儲存',
		saved: '已儲存',
		available: '可新增的訊息類型',
		no_more: '— 沒有更多了 —',
		row_label: '{{label}}，第 {{position}} 項，共 {{total}} 項',
		remove_label: '移除「{{label}}」',
		add_label: '新增「{{label}}」',
		move_up_label: '上移「{{label}}」',
		move_down_label: '下移「{{label}}」',
		unread_card_label: '未讀訊息：{{title}}',
		status: { unread: '未讀' },
		kp: {
			arrive_time: '到店時間',
			store: '所到門店',
			name: '姓名',
			sex: '性別',
			male: '男',
			female: '女',
			record: '到店記錄',
			arrive_n_times: '到店{{n}}次',
		},
		pos: {
			fallback: '交易訊息',
			type_1: '銷售',
			type_2: '退款',
			type_3: '充值',
			type_4: '報損',
			type_5: '抹零',
			type_6: 'AI 異常',
			type_7: '修正',
			type_8: '退單退貨',
			type_9: '反結賬',
			type_10: '打折單',
			type_11: '外送退單',
			type_12: '拒絕訂單',
			type_13: '異常取消',
			type_14: '異常退單',
			type_15: '免單',
		},
	},
	msg_t: {
		system: '系統訊息',
		event: '事件訊息',
		examine: '考評訊息',
		key_person: '重點人員到店',
		blacklist: '黑名單警告',
		xundian: '巡店訊息',
		tuogang: '脫崗訊息',
		pic_ai: '圖片AI檢測',
		move_ai: '影片AI檢測',
		face_mask: '未戴口罩提醒',
		data_warn: '資料預警',
		cert: '證書管理訊息',
		youschool: '悠學堂',
		store_build: '開店籌建',
		image_exception: '畫面異常檢測',
		alarm: '警告',
		human_alarm: '人形警告',
		face: '人臉辨識',
		ai_tag_video: 'AI 影片',
		pos_trade: 'POS 交易',
		dianjian: '點檢訊息',
	},
	eval: {
		search_ph: '搜尋任務',
		expired_tasks: '過期任務',
		no_active: '暫無進行中的任務',
		no_expired: '暫無過期任務',
		valid_time: '有效時間',
		to: '至',
		cycle: '任務週期',
		frequency: '任務頻次',
		times: '次',
		eval_stores: '考評門店',
		done_stores: '已考評店',
		unit_store: '家',
		unit_copy: '份',
		progress: '任務進度',
		submit_count: '提交報告',
		remote_eval: '遠程考評',
		onsite_eval: '現場考評',
		view_report: '查看報告',
		detail_title: '查看任務',
		template: '考評模版',
		evaluators: '考評人',
		recent_reports: '最近已提交報告',
	},
	rp: {
		tab_records: '獎懲記錄',
		tab_levels: '獎懲級別',
		all_rp: '全部獎懲',
		reward: '獎勵',
		penalty: '懲罰',
		last_7d: '近 7 天',
		last_30d: '近 30 天',
		last_90d: '近三個月',
		sort_by_create: '按建立時間',
		add: '新增',
		edit: '編輯',
		delete: '刪除',
		confirm_delete: '確認刪除此級別？',
		deleted: '已刪除',
		delete_failed: '刪除失敗',
		edit_title: '編輯級別',
		add_title: '新增級別',
		save: '儲存',
		saved: '已儲存',
		save_failed: '儲存失敗',
		type: '類型',
		level_name: '級別名稱',
		level_name_ph: '請輸入級別名稱',
		amount: '獎懲金額',
		amount_ph: '請輸入金額',
		usage: '使用情況',
		usage_ph: '請輸入使用情況說明',
		title_required: '請輸入級別名稱',
		amount_required: '請輸入有效金額',
	},
	hot: {
		select_store: '選擇門店：',
		date: '日期：',
		pick_store: '請先選擇門店',
		no_device: '此門店無熱區設備',
		not_configured: '此設備尚未設定熱區分析（無區域定義）',
		filter_areas: '篩選區域',
		show_all: '全部顯示',
		hide_all: '全部隱藏',
		stay_label: '停留時間：',
		seconds: '{{n}} 秒',
		keliu: '客流人次',
		stop: '駐足人次',
		stop_rate: '駐足率',
		avg_stay: '平均停留時長',
	},
	traffic: {
		total_vehicles: '車輛總數',
		avg_plate: '平均車牌辨識',
		hourly_trend: '車流時段趨勢',
	},
	leavepost: {
		no_records: '當日無脫崗紀錄',
		duration: '脫崗時長',
	},
	auth: {
		login_title: '帳號登入',
		account: '帳號',
		account_required: '請輸入帳號',
		password: '密碼',
		password_required: '請輸入密碼',
		login: '登 入',
		login_success: '登入成功',
		login_failed: '登入失敗',
		session_elsewhere: '偵測到你的帳號已在別處登入，請重新登入。',
		remember_account: '記住帳號',
		logout: '登出',
		logged_in_as: '目前帳號',
		tip_internal_dev: '目前為開發聯調模式，呼叫 ulucu 內部 API（待開放平台憑證就緒後切換）',
	},
	home: {
		welcome: '歡迎使用 Ulucu',
		intro: '門店管理用戶端 · 多語言版本（中 / 繁 / 英 / 西 / 阿）',
		store_count: '共 {{count}} 家門店',
		has_device: '有設備',
	},
	dashboard: {
		online_rate: '設備線上率',
		device_status: '設備狀態分布',
	},
	device: {
		total: '設備總數',
		online: '線上',
		offline: '離線',
		channels: '通道',
		off_time: '離線時間',
		select_device: '選擇設備',
	},
	daterange: {
		today: '今天',
		'7d': '近 7 天',
		'30d': '近 30 天',
	},
	cust: {
		tab_portrait: '顧客畫像',
		tab_precise:  '精準客流分析',
		tab_batch:    '批次客流',
		tab_realtime: '即時客流',
		tab_consume:  '消費分析',
		tab_device:   '設備分析',
		filter: '篩選',
		current_n_stores: '目前 {{n}} 個門店',
		overview: '資料總覽',
		portrait_total: '顧客畫像總數',
		most_portrait: '多數到店顧客畫像-精準',
		unit_person: '人',
		member_ratio: '會員佔比',
		gender_ratio: '性別佔比',
		age_ratio: '年齡佔比',
		age_x_gender: '年齡與性別分析',
		age_x_identity: '年齡與身份分析',
		member: '會員',
		non_member: '非會員',
		male: '男',
		female: '女',
		precise_wip_title: '精準客流分析',
		precise_wip_desc: '資料總覽 + 客流分佈 + 轉化漏斗 + 停留時長 + 門店排行（待補完）',
		mom: '環比',
		yoy: '同比',
		sub_flow: '客流分佈',
		sub_funnel: '轉化漏斗',
		sub_stay: '停留時長分析',
		sub_rank: '門店排行',
		gran_hour: '時',
		gran_day: '天',
		flow_trend: '客流總體趨勢',
		kpi: {
			pass: '經過客流',
			enter: '進店客流',
			enter_rate: '進店轉化率',
			try: '試穿客流',
			try_rate: '試穿轉化率',
			member: '到店會員',
			stay_avg: '人均停留時長 (分)',
			deal_rate: '成交轉化率',
			bind_device: '請綁定離店設備',
			daily_avg: '日均客流',
			peak: '客流峰值 ({{date}})',
			valley: '客流谷值 ({{date}})',
		},
	},
	customer: {
		title: '客流分析',
		date: '日期',
		pass_count: '經過客流',
		enter_count: '進店客流',
		unit: '人',
		raw_response: '原始回應',
		hourly_trend: '客流時段趨勢',
	},
	member: {
		overview: '概覽',
		customer_list: '顧客清單',
		total: '老顧客總數',
		new_count: '新顧客',
		return_count: '回頭客',
		visit_count: '到店 {{count}} 次',
		last_visit: '最近到店',
		start_from: '起始日期',
		anonymous: '匿名顧客',
	},
	event: {
		range: '時間範圍',
		total: '共 {{count}} 筆',
	},
	event_count: {
		all: '全部事件',
		wait: '待處理',
		wait_handle: '需處理',
		destroy: '已撤銷',
		my: '我的事件',
		my_appeal: '我的申訴',
		appeal_audit: '申訴審核',
		recheck: '複核',
	},
	live: {
		online_devices: '設備清單',
		no_online: '此門店暫無設備',
		play_live: '即時直播',
		get_play_token: '取得播放憑證',
		play_token_for: '播放憑證 · ',
		cloud_storage: '雲端儲存',
		web_limitation: 'Web 即時影片說明',
		web_limitation_desc: '已驗證 internal API /play/weburl 直接回傳 HFLV URL，瀏覽器透過 flv.js 即可播放即時畫面（1-2s 延遲）。下方 PoC 示範已通過真實攝影機驗證。',
		token_only_note: '已取得 play_token（內部 API 路徑，給 native SDK 用）。 internal /play/weburl 是 web 用的等價路徑（推薦）。',
		poc_title: 'HFLV 瀏覽器能力 PoC',
		poc_intro: '驗證 flv.js + 瀏覽器可播 HFLV 通訊協定',
		poc_intro_desc: '使用公開測試流驗證瀏覽器/Capacitor WebView 相容性。已通過實機真攝影機驗證。',
		test_stream: '測試流',
		play: '播放',
		stop: '停止',
		reload: '重新載入',
		logs: '記錄檔',
		missing_sn: '設備缺少 SN，無法播放',
	},
	scan: {
		browser_supported: '瀏覽器掃碼能力可用',
		browser_unsupported: '目前瀏覽器不支援掃碼',
		browser_supported_desc: 'Web 端可呼叫瀏覽器 BarcodeDetector；行動 App 會接入原生相機掃碼。',
		browser_unsupported_desc: '請在支援相機掃碼的行動 App 或相容瀏覽器中使用。',
		capacitor_plan: 'iOS / Android 版本將使用原生掃碼能力；目前 Web 端僅展示能力狀態。',
		start_scan: '開始掃碼',
	},
	modules: {
		dashboard: '首頁',
		device: '設備',
		store: '門店',
		live: '即時影片',
		event: '事件中心',
		alert: '告警',
		inspect: '巡檢',
		patrol: '巡店',
		leavepost: '脫崗',
		customer: '客流分析',
		traffic: '車流統計',
		heatmap: '熱區分析',
		pos: '收銀疊加',
		scan: '掃碼',
		auth: '登入',
		member: '會員管理',
		evaluation: '評估考核',
		wechatvip: '企微VIP',
		figurewarning: '人形告警',
		university: '悠絡客大學',
		staff: '員工管理',
		guard: '值守',
		message: '訊息中心',
		rewardpunish: '獎懲',
		smartlistening: '智能聽店',
		cloudstorage: '雲端儲存',
		phonelive: '手機直播',
		sharedevice: '設備共享',
		datawarn: '資料預警',
		aipatrol: 'AI 巡檢',
		reportaudit: '報告審核',
	},
	reportaudit: {
		title: '報告審核',
		tab: { audit: '審核管理', self: '自檢管理' },
		filter: { store: '選擇門店', date: '選擇日期', status: '報告狀態', template: '模板篩選' },
		status: { pending: '待審核', passed: '已通過', rejected: '未通過' },
	},
	changelog: {
		unread: '未讀',
		load_more: '載入更多',
		no_more: '— 沒有更多了 —',
	},
	album: {
		empty: '暫無截圖',
		local: '本地截圖',
		edit: '編輯',
		delete: '刪除',
		deleted: '已刪除',
		delete_failed: '刪除失敗',
		select_first: '請先選擇截圖',
		selected_n: '已選 {{n}} 張',
		confirm_delete: '確認刪除選中的 {{n}} 張截圖？',
		load_more: '載入更多',
		no_more: '— 沒有更多了 —',
	},
	aipatrol: {
		title: 'AI 巡檢',
		banner_title: 'AI 智慧巡檢',
		banner_subtitle: '7×24 自動識別異常，告別人工巡檢',
		unnamed_model: '未命名模型',
		sec: { pic: '圖片 AI 檢測', video: '影片 AI 檢測', other: '其他' },
		app: {
			datacenter: '數據中心',
			stats: '統計',
			report: '巡店報告',
			leavepost: '脫崗檢測',
			gallery: '圖片庫',
			alert: '警報',
		},
		dc: {
			title: '數據中心',
			fav: '收藏夾',
			last7d: '近 7 天',
			all_stores: '全部門店',
			all_models: '全部模型',
			load_more: '點擊或上拉載入更多',
			no_more: '— 沒有更多了 —',
		},
		kpi: { stores: '開通門店數', devices: '開通設備數' },
		alarm: {
			title_yesterday: '昨日報警統計',
			count_label: '報警次數',
			load_more: '載入更多',
			latest: '最新報警統計',
		},
		stats: {
			title: '統計',
			last7d: '近七天',
			all_tasks: '全部任務',
			all_stores: '全部門店',
			all_users: '全部巡查人',
			violation_total: '總違規數',
			violation_type_count: '違規類型數',
			store_total: '選擇門店總數',
			patroller_count: '總巡查人數',
			report_submit_count: '已提交報告數',
			trend: '門店整體趨勢',
			dim_day: '日',
			dim_month: '月',
			rank: '違規項排名',
			view_more: '查看更多',
			col_item: '違規項名稱',
			col_count: '違規數',
			col_stores: '違規門店數',
		},
	},
	rep: {
		title: '統計報表',
		dash: '至',
		last_7d: '近 7 天',
		today: '今日',
		no_content: '暫無內容',
		unit: { person: '人', percent: '%', yuan: '元' },
		cust: {
			title: '顧客分析',
			this_month: '本月',
			gdrs: '經過客流',
			jdkl: '進店客流',
			jzkl: '精準進店客流',
			jdzhl: '進店轉化率',
			xsze: '銷售額',
		},
		youxun: {
			title: '悠巡',
			alarm_count: '警報統計',
			most_store: '警報最多門店',
			times: '次',
			none: '暫無',
		},
		xdt: {
			title: '巡店通',
			unit: '份',
			examine_submit: '提交考評',
			examine_waiting: '待審核報告數',
			examine_today: '今日考評任務',
			inspect_submit: '提交自檢',
			inspect_waiting: '自檢待審核',
			inspect_today: '今日自檢任務',
			dj_handled: '點檢已處理',
			dj_waiting: '點檢待處理',
			dj_expired: '逾期未檢',
		},
		event: {
			title: '事件統計',
			total: '事件總數',
			pending: '待處理事件數',
			key: '重點事件類型',
			unit: '件',
			none: '暫無',
		},
		editor: {
			btn: '排序與新增',
			title: '動態排序與新增',
			cancel: '取消',
			ok: '確定',
			advanced: '進階設定',
			shown: '動態頁顯示的模組',
			available: '可新增的模組',
		},
		advanced: {
			title: '悠巡 進階設定',
			search_ph: '搜尋 AI 模型名稱或 ID',
			counter: '已訂閱 {{picked}} / 全部 {{total}}',
			saved: '訂閱已儲存',
			save_failed: '儲存失敗',
		},
	},
	mselect: {
		title: '影片播放篩選',
		search_ph: '輸入設備名稱',
		counter: '在線設備 {{online}}，已選擇 {{picked}} 個',
		no_online: '此門店無在線設備',
		watch: '觀看影片',
	},
	vfilter: {
		title: '篩選',
		device: '門店設備',
		has_dev: '有設備',
		no_dev: '無設備',
		status: '設備狀態',
		online: '在線',
		offline: '離線',
		fav_status: '收藏狀態',
		faved: '已收藏',
		unfaved: '未收藏',
		sort: '門店排序',
		sort_create: '按建立時間排序',
		sort_name: '按名稱 A-Z 排序',
		reset: '重置',
		ok: '確定',
	},
	sov: {
		compare: '環比',
		rank_title: '此門店資料排行',
		b_avg: '企業平均',
		exceed: '超過 {{pct}}% 的門店',
		avg: '均值',
		settings_title: '門店資料設定',
		selected_data: '已選資料',
		selected_hint: '按住拖動調整順序',
		done: '完成',
		saved: '已儲存',
		save_failed: '儲存失敗',
		cat: {
			business: '營業資料',
			traffic: '客流資料',
			event: '管理資料',
		},
		p: {
			hour: '時',
			day: '天',
			week: '週',
			month: '月',
			quarter: '季',
		},
		t: {
			jzkl: '精準進店客流',
			gdrs: '經過客流',
			gdrs_f: '經過客流(F)',
			jdzhl: '進店轉化率',
			xfds: '訂單數',
			xsze: '銷售額',
			cjl: '成交轉化率',
			sjzs: '事件總數',
			dclsjs: '待處理事件數',
			zkl: '總客流',
			jtlsc: '人均停留時長',
			kdj: '客單價',
			ldl: '連帶率',
		},
	},
	native: {
		common: {
			all: '全部',
			clear: '清空',
			date: '日期',
			phone: '電話',
			remove_picture: '移除圖片',
			submit: '提交',
			view_all: '檢視全部',
			back: '返回',
			cancel: '取消',
			complete: '完成',
			confirm: '確認',
			copy: '複製',
			default: '預設',
			details: '詳情',
			edit: '編輯',
			filter: '篩選',
			from_high_to_low: '由高到低',
			level: '等級',
			no_content: '暫無內容',
			no_data: '暫無資料',
			online: '在線',
			offline: '離線',
			operation_failed: '操作失敗',
			organization: '組織',
			people: '人',
			pcs: '個',
			picture: '圖片',
			refresh: '重新整理',
			reset: '重設',
			save: '儲存',
			search: '搜尋',
			search_by_store_name: '按門店名稱搜尋',
			search_history: '搜尋歷史',
			store: '門店',
			video: '影片',
			all_stores: '全部門店',
			all_status: '全部狀態',
			all_tasks: '全部任務',
			all_executors: '全部執行人',
		},
		settings: {
			title: '設定',
			modify_password: '修改密碼',
			language_setting: '語言設定',
			clear_cache: '清除快取',
			clear_cache_confirm: '確認清除快取？',
			about_us: '關於我們',
			logout: '登出',
			old_password: '舊密碼',
			new_password: '新密碼',
			confirm_password: '確認密碼',
		},
		profile: {
			my_album: '我的相簿',
			watch_history: '觀看歷史',
			online_repair: '線上報修',
			repair_record: '報修記錄',
			setting: '設定',
		},
		home: {
			title: '首頁',
			latest_news: '最新消息',
			assessment: '考核',
			today: '今天',
			assessment_empty: '暫無內容',
			submitted: '提交考核',
			waiting_approve: '待審批',
			event: '事件',
			recent_7_days: '近 7 天',
			events: '事件',
			pending_events: '待處理事件',
			key_type: '重點事件類型',
			ranking: '排序與顯示',
			organization: '組織',
			message: '消息中心',
			system_message: '系統消息',
			event_message: '事件消息',
			evaluation_message: '考核消息',
			store_inspection_message: '門店巡檢消息',
			no_new_message: '暫無新消息',
			new_message: '新消息',
			no_latest_news: '暫無最新消息',
			last_update: '最後更新：',
			no_data_last_2_days: '近 2 天暫無資料~',
			management: '管理',
			statistics: '統計',
			report: '報告',
			my_assessment: '我的考核',
			audits: '審核',
			draft_box: '草稿箱',
			report_status: '報告狀態',
			template: '範本',
			pending: '待處理',
			to_be_accepted: '待受理',
			processed: '已處理',
			expired: '已過期',
			deleted: '已刪除',
			total_events: '事件總數',
			event_types: '事件類型',
			message_content_aria: '消息內容',
			message_aria: '消息',
			create_event: '建立事件',
			submit: '提交',
			select_store: '選擇門店',
			please_choose_store: '請選擇門店',
			please_choose_event_type: '請選擇事件類型',
			event_scoring: '事件評分',
			priority: '優先級',
			assign_to: '指派給',
			follower: '關注人',
			remarks_placeholder: '備註 最多 3000 字',
			add_3_pictures: '最多新增 3 張圖片',
			confirm: '確認',
			select_all: '全選',
			store_name: '門店名稱',
			name: '名稱',
			please_input_key_words: '請輸入關鍵字',
			please_input_key_words_title: '請輸入關鍵字',
			choose_store_required: '請選擇門店',
			choose_event_type_required: '請選擇事件類型',
			priority_source_pending: '優先級資料未就緒',
			scoring_required: '請選擇事件評分',
			property_required: '請選擇評分項',
			choose_assignor_required: '請選擇指派人',
			picture_required: '請先選擇或補充圖片',
			event_created: '建立成功',
			choose_store_first: '請先選擇門店',
			please_select_assignor: '請選擇指派人',
			please_select_follower: '請選擇關注人',
			select_assignor: '選擇指派人',
		},
		application: {
			title: '應用',
			display_title: '排序與顯示',
			display_subtitle: '應用頁面顯示模組',
			fixed: '固定',
			saved: '應用顯示已儲存',
			reset_done: '已恢復預設排序',
			last_visible: '至少保留一個應用可見',
			move_up: '上移',
			move_down: '下移',
			show: '顯示',
			hide: '隱藏',
			function_intro: '功能介紹',
			permission_denied: '您沒有此模組的使用權限。',
			groups: {
				store: '門店數位化',
				standard: '標準化管理',
				marketing: '智慧行銷',
				data: '資料中心',
			},
			items: {
				customer_flow_analysis: '客流分析',
				traffic_flow: '車流統計',
				heat_map: '熱力圖',
				event: '事件',
				shake_inspection: '搖一搖巡檢',
				off_duty_patro: '離崗巡檢',
				timed_inspection: '定時巡檢',
				timed_snapshot_inspection: '定時截圖巡檢',
				assessment: '考核',
				qr_code_scan_superposition: '二維碼掃碼疊加',
				intelligent_attendance: '智慧考勤',
				reward_punish: '獎懲',
				smart_listening: '智慧聽音',
				shopping_guide: '導購',
				intelligent_classroom: '智慧課堂',
				customer_flow_alert: '客流預警',
				ranking_display: '排序與顯示',
				phone_live: '手機直播',
				smart_marketing: '智慧行銷',
				data_center: '資料中心',
				cloud_storage: '雲端儲存',
			},
		},
		store: {
			device_list: '設備列表',
			data: '資料',
			access_camera: '進入攝影機',
			repair_record: '報修記錄',
			store_creation_time: '門店建立時間',
			camera_setting: '攝影機設定',
			camera_name: '攝影機名稱',
			cloud_storage: '雲端儲存',
			local_storage: '本地儲存',
			connect_other_wifi: '連接其他 Wi-Fi',
			no_longer_use: '不再使用',
			connect_camera_to_store: '將攝影機連接到門店',
			compared_previous: '較上一週期',
			events: '事件',
			events_to_be_processed: '待處理事件',
			data_ranking: '門店資料排名',
			store_data_setting: '門店資料設定',
			data_selected_hint: '已選資料（長按拖動調整順序）',
			manage_data: '管理資料',
			max_metrics: '最多選擇 {{count}} 個指標',
			keep_one_metric: '請至少保留一個指標',
			chart_visibility: '圖表顯示設定',
			average: '均值',
			compared_previous_range: '（較上一週期{{range}}）',
			ranking_detail_with_unit: '企業平均 {{average}}{{unit}}，門店超越 {{exceed}}%',
			period_hour: '小時',
			period_day: '天',
			period_week: '週',
			period_month: '月',
			period_quarter: '季度',
			full_storage: '全量儲存',
			mobile_detection_storage: '移動偵測儲存',
			set_storage_schedule: '設定儲存計畫',
			entry_number: '進店人數',
			device_layout_preview: '預覽布局',
			device_layout_list: '列表布局',
			device_is_offline: '設備已離線',
			offline_time: '離線時間',
			offline_duration: '離線時長',
			setting_unavailable: '該設定暫不支援在 Web 使用。',
			pieces: '{{count}} 個',
			ranking_detail: '企業平均 {{average}} 個，超越 {{exceed}} 門店',
			cloud_storage_banner_auto_detect: '自動偵測，雲端儲存',
			cloud_storage_banner_look_back: '隨時回看',
			cloud_storage_banner_encryption: '嚴格加密，安全可靠',
			cloud_storage_unavailable_line1: '該設備的雲端儲存服務',
			cloud_storage_unavailable_line2: '暫不可用。',
			contact_administrator: '請聯絡管理員。',
			memory_card_recording: '開啟記憶卡錄影',
			memory_card_type: '選擇記憶卡類型',
			internal_storage_space: '內部儲存空間',
			storage_available: '可用{{value}}',
			storage_total: '總計{{value}}',
			format_memory_card: '格式化記憶卡',
			storage_status_normal: '正常',
			memory_card_format_hint: '格式化後，部分記憶卡空間將用於儲存系統檔案，顯示的剩餘容量可能小於記憶卡實際容量。',
			memory_card_non_standard_tip: '提示：該記憶卡為非標準卡。請使用標準卡以保障資料安全',
		},
		repair: {
			add_picture: '新增圖片',
			fault_tip: '請描述故障現象和相關操作步驟，以便工程師盡快解決。',
			pictures_tip: '請上傳相關圖片供我們參考，以便高效解決問題。',
			record: '報修記錄',
			date_range: '日期範圍',
			status_submitted: '已提交',
			status_processing: '處理中',
			repair_no: '報修編號',
			select_store: '選擇門店',
			contact_person: '聯絡人',
			contact_number: '聯絡電話',
			tel: '電話',
			store_prefix: '門店',
			fault_description: '故障描述',
			submission_time: '提交時間',
			images: '圖片',
			no_images: '暫無圖片',
		},
		snapshot: {
			timed_snapshot_inspection: '定時截圖巡檢',
			inspection_statistics: '巡檢統計',
			inspection_data: '巡檢資料',
			inspection_task: '巡檢任務',
			create_inspection: '建立巡檢',
			store_data_statistics: '門店資料統計',
			executor_statistics: '執行人統計',
			start_date: '開始日期',
			end_date: '結束日期',
			load_failed: '載入失敗',
			apac_only: '定時截圖巡檢僅在海外版接入。',
			all_planned_screenshot: '全部計畫截圖',
			current_screenshot: '目前截圖',
			current_processed: '目前已處理',
			overdue_unprocessed: '逾期未處理',
			all_unprocessed: '全部未處理',
			maximum_violations: '最高違規數',
			minimum_violations: '最低違規數',
			account: '帳號',
			full_name_role: '姓名（角色）',
			to_be_processed: '待處理',
			processed: '已處理',
			rank: '排名',
			task_status: '任務狀態',
			enabled: '啟用中',
			disabled: '已關閉',
			plan_opened_success: '計畫開啟成功',
			plan_closed_success: '計畫關閉成功',
			plan_status_failed: '計畫狀態更新失敗',
			delete_task: '刪除任務',
			delete_success: '刪除成功',
			delete_failed: '刪除失敗',
			today_screenshots: '今日截圖',
			today_processed: '今日已處理',
			total_unprocessed: '全部未處理',
			total_unqualified: '全部不合格',
			task_store: '任務門店',
			stores_suffix: '個門店',
			executor: '執行人',
			people_suffix: '人',
			task_time: '任務時間',
			execution_cycle: '執行週期',
			task_name: '任務名稱',
			detail_information: '詳細資訊',
			execution_date: '執行日期',
			execution_month: '執行月份',
			assessment_template: '考核模板',
			select_template: '選擇模板',
			store: '門店',
			select_executor: '選擇執行人',
			device_point: '設備',
			select_device: '選擇設備',
			execution_time: '執行時間',
			add_time: '新增時間',
			validation_template: '請選擇考核模板',
			save_success: '儲存成功',
			save_failed: '儲存失敗',
			qualified: '合格',
			unqualified: '不合格',
			process_success: '處理成功',
			process_failed: '處理失敗',
			mon: '週一',
			tues: '週二',
			wed: '週三',
			thur: '週四',
			fri: '週五',
			sat: '週六',
			sun: '週日',
			ranking_all_stores: '全部門店排名',
			total_violations: '違規總數',
			ranking: '排名',
			violation_items_ranking: '違規項目排名',
			items_name: '項目名稱',
			violation_numbers: '違規數量',
			percentage: '占比',
			daily_violation_item: '每日違規趨勢（按違規項目）',
			daily_violation_store: '每日違規趨勢（按門店）',
		},
		evaluation: {
			management: '管理',
			store: '門店',
			by_score: '按分數',
			by_store: '按門店',
			select_task: '選擇任務',
			select_store: '選擇門店',
			select_user: '選擇使用者',
			select_stores_count: '選擇({{count}})門店',
			select_tasks_count: '選擇({{count}})任務',
			search_store: '搜尋門店',
			deselect_all: '取消全選',
			keyword_placeholder: '請輸入關鍵字',
			user_keyword_placeholder: '請輸入關鍵字...',
			expired_tasks: '過期任務',
			no_tasks_in_progress: '暫無進行中的任務',
			select_date: '選擇日期',
			today: '今天',
			recent_7_days: '近 7 天',
			recent_30_days: '近 30 天',
			recent_90_days: '近 90 天',
			recent_180_days: '近 180 天',
			customize: '自訂',
			start_date: '開始日期',
			end_date: '結束日期',
			select_user_count: '選擇({{count}})使用者',
			select_templates_count: '選擇({{count}})模板',
			please_select: '請選擇',
			please_input: '請輸入',
			please_input_keywords: '請輸入關鍵字',
			store_name: '門店名稱',
			name: '名稱',
			select_all: '全選',
			location_permission: '需要開啟定位權限以取得附近門店',
			reviewer: '審核人',
			submitter: '提交人',
			title: '考核',
			assessment_today: '今日考核',
			assigned_to_me: '分配給我',
			remote_assessment: '遠端考核',
			onsite_assessment: '現場考核',
			my_task: '我的任務',
			ranking: '排名',
			task_progress: '任務進度：',
			report: '報告',
			my_assessment: '我的考核',
			audits: '審核',
			draft_box: '草稿箱',
			date: '日期',
			report_status: '報告狀態',
			template: '模板',
			assessment_details: '考核詳情',
			assessment_time: '考核時間',
			score: '分數',
			assessment_task: '考核任務',
			source: '來源',
			assessment_content: '考核內容',
			filter_full_score_item: '過濾滿分項',
			standard: '標準',
			qualified: '合格',
			unqualified: '不合格',
			passed: '已通過',
			failed: '未通過',
			remarks: '備註',
			no_picture: '暫無圖片',
			no: '無',
		},
		inspect: {
			empty: '您尚未新增門店巡檢計畫~',
			add_plan: '新增計畫',
			title: '定時巡檢',
			add_title: '新增計畫',
			plan: '計畫',
			plan_name: '計畫名稱',
			select_store: '選擇門店',
			select_device: '選擇設備',
			equipment_location: '設備點位',
			store_inspection_time: '門店巡檢時間',
			set_time: '設定門店巡檢時間',
			submit_plan: '提交計畫',
			confirm: '確認',
			cancel: '取消',
			select_all: '全選',
			store_name: '門店名稱',
			equipment_name: '設備名稱',
			search_keywords: '請輸入關鍵字',
			equipment_search: '設備搜尋',
			no_stores: '暫無門店',
			no_devices: '暫無設備',
			store_count: '巡檢門店數量',
			stores: '個門店',
			inspection_time: '門店巡檢時間',
			running_state: '運行狀態',
			executing: '執行中',
			closed: '已關閉',
			detail_title: '門店巡檢計畫詳情',
			update_time: '更新時間',
			enabled: '已啟用',
			off_state: '關閉狀態',
			intelligent: '智慧',
			time: '時間',
			no_data: '暫無資料',
			refresh: '刷新',
			plan_opened_success: '計畫開啟成功',
			plan_closed_success: '計畫關閉成功',
			plan_status_failed: '計畫狀態更新失敗',
			picture_preview: '圖片預覽',
			picture_load_failed: '圖片載入失敗',
			create_event: '建立事件',
			download_picture: '下載圖片',
			intelligent_options: '智慧選項',
			intelligent_options_title: '請選擇門店巡檢智慧選項',
			intelligent_option_roughly: '此處大致符合要求',
			intelligent_options_learning: '了解更多智慧選項...',
			intelligent_options_tip: '提示：啟用智慧選項後，不符合選項的門店巡檢圖片將單獨列出。但如果攝影機發生偏移，結果可能不準確甚至無效。此時可以重新設定該點位的智慧選項。',
			choose_later: '稍後選擇',
			device_context_missing: '設備資訊不可用',
			message_context_missing: '消息資訊不可用',
			picture_unavailable: '圖片不可用',
			add_success: '新增計畫成功',
			delete: '刪除',
			delete_confirm_title: '刪除計畫',
			delete_confirm_body: '確定刪除此定時巡檢計畫？',
			delete_success: '計畫已刪除',
			delete_failed: '刪除失敗',
			load_failed: '定時巡檢計畫載入失敗',
			submit_failed: '提交失敗',
			validation_plan_name: '請輸入計畫名稱',
			validation_store: '請選擇門店',
			validation_device: '請選擇設備',
			validation_time: '請選擇巡檢時間',
			validation_user: '缺少目前使用者 ID',
			validation_item: '巡檢項元資料不完整',
			hour: '時',
			minute: '分',
			time_slot_1: '請選擇第一次門店巡檢時間',
			time_slot_2: '請選擇第二次門店巡檢時間',
			time_slot_3: '請選擇第三次門店巡檢時間',
			time_slot_4: '請選擇第四次門店巡檢時間',
			time_slot_5: '請選擇第五次門店巡檢時間',
			time_slot_6: '請選擇第六次門店巡檢時間',
			time_slot_7: '請選擇第七次門店巡檢時間',
			time_slot_8: '請選擇第八次門店巡檢時間',
			time_slot_9: '請選擇第九次門店巡檢時間',
			time_slot_10: '請選擇第十次門店巡檢時間',
		},
	},
};
